import BillingHTTP from 'utils/billing-http';

class ConfigsService {
  getConfigs() {
    return BillingHTTP.get('/dashboard-api/v2/configs');
  }

  loadConfig() {
    return BillingHTTP.getContent('/dashboard-api/v2/config');
  }
}

export default new ConfigsService();
